import type { InboxConversationListHeaderProps } from '../../CentralInbox.types';

import { Loader, Typography } from '@recruit-robin/robin-theme/web-components';
import { Switch } from 'components/ui/atoms';
import { CommunicationChannelsDots } from 'components/ui/molecules/CommunicationChannelsDots';
import { usePageContext } from 'hooks/shared/usePageContext';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useGetUnreadConversationsAmount } from 'shared/legacy/hooks/useGetUnreadConversationsAmount';
import { useInboxStore } from 'stores/inbox/inbox.store';
import { useStyles } from './InboxConversationListHeader.styles';

export const InboxConversationListHeader = ({ showTeamView = true }: InboxConversationListHeaderProps) => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);
  const pageContext = usePageContext();
  const teamView = useInboxStore((s) => s.isTeamViewEnabled);
  const toggleTeamView = useInboxStore((s) => s.toggleTeamView);
  const { data: unreadAmount, isLoading } = useGetUnreadConversationsAmount(
    pageContext === PageContext.CentralInbox ? teamView : false,
  );

  return (
    <div css={classes.root}>
      <div css={classes.labels}>
        <span css={classes.label}>{dictionary.inbox}</span>
        <span css={classes.unreadConversationsAmount}>
          {isLoading ? (
            <div css={classes.loader}>
              <Loader color={(c) => c.neutral.gray} size={14} />
            </div>
          ) : (
            <Typography
              css={classes.amount}
              variant={(v) => v.supporting['label-tiny']}
              color={(v) => v.neutral.gray[0]}>
              {(unreadAmount ?? 0) <= 99 ? unreadAmount : '99+'}
            </Typography>
          )}
        </span>
      </div>
      {pageContext === PageContext.CentralInbox && <CommunicationChannelsDots />}
      {showTeamView && (
        <Switch
          onChange={() => toggleTeamView()}
          checked={teamView}
          label={{ off: dictionary.teamView.toUpperCase() }}
          labelVariant={(v) => v.supporting['label-tiny']}
          variant="smaller"
        />
      )}
    </div>
  );
};
